import request from '@/utils/request'

/**
 * 查询管理员店铺订单购物车
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryAdminStoreOrderCart(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryAdminStoreOrderCart',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询管理员店铺列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopsByAdmin(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopsByAdmin',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}